import React from "react";

const OptimizedImage = ({ webpSrc, fallbackSrc, alt, ...props }) => {
  const resolvedFallback = fallbackSrc || webpSrc;
  const showWebp = webpSrc && webpSrc !== resolvedFallback;

  return (
    <picture>
      {showWebp && <source srcSet={webpSrc} type="image/webp" />}
      <img src={resolvedFallback} alt={alt} {...props} />
    </picture>
  );
};

export default OptimizedImage;
